var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-6"},[_c('h5',{staticClass:"mt-2"},[_vm._v(" "+_vm._s(_vm.countItems)+" dari "+_vm._s(_vm.countItemsAll)+" data Ditampilkan ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }